import { AxiosInstance } from "axios";
import { PendingLicencePurchase } from "../types/PendingLicencePurchase/PendingLicencePurchase";
import { PendingLicencePurchaseSummary } from "../types/PendingLicencePurchase/PendingLicencePurchaseSummary";

export default class PendingLicencePurchaseService {
  private _endpoint = "PendingLicencePurchase";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async getPendingLicencePurchase(
    pendingLicencePurchaseId: string,
    hash: string
  ): Promise<PendingLicencePurchase | null> {
    const response = await this._client.get<PendingLicencePurchase>(
      `${this._endpoint}?pendingLicencePurchaseId=${encodeURIComponent(
        pendingLicencePurchaseId.trim()
      )}&hash=${encodeURIComponent(hash.trim())}`
    );
    return response.data;
  }

  public async updateCurrency(
    pendingLicencePurchaseId: string,
    hash: string,
    transactionCurrencyCode: string
  ): Promise<null> {
    const response = await this._client.put(
      `${this._endpoint}?pendingLicencePurchaseId=${encodeURIComponent(
        pendingLicencePurchaseId.trim()
      )}&hash=${encodeURIComponent(
        hash
      )}&transactionCurrencyCode=${encodeURIComponent(
        transactionCurrencyCode.trim()
      )}`
    );
    return response.data;
  }

  public async create(
    transactionCurrencyCode: string
  ): Promise<PendingLicencePurchaseSummary> {
    const response = await this._client.post(
      `${this._endpoint}/create/${transactionCurrencyCode}`
    );

    return response.data;
  }
}
